import * as React from 'react';
import { MISSING_VALUE_PLACEHOLDER } from '../../constants';
import Icon from '../../widgets/Icons';
import ScaledCount from '../../widgets/ScaledCount';
import ScorePanel from '../../widgets/ScorePanel';
import LoadingIndicator from '../../widgets/LoadingIndicator';

type Props = {
  className?: string;
  totalInvestigations: number | null;
  isLoading: boolean;
};

export default class InvestigationScore extends React.Component<Props> {
  render() {
    const { className, totalInvestigations: value, isLoading } = this.props;
    const decimals = value && Number.isFinite(value) && value > 1000 ? 2 : 0;

    return (
      <ScorePanel
        className={className}
        icon={<Icon.UserSecret />}
        title={'Monthly Investigations'}
        score={
          isLoading ? (
            <div className="score-bar">
              <LoadingIndicator size="lg" />
            </div>
          ) : (
            <h1>
              {value && Number.isFinite(value) ? (
                <ScaledCount count={value} decimals={decimals} />
              ) : (
                MISSING_VALUE_PLACEHOLDER
              )}
            </h1>
          )
        }
      >
        Number of data points your Concierge Security Team has investigated from
        your environment.
      </ScorePanel>
    );
  }
}
